import { Reveal, SectionHead } from "./Section";
import { IMG } from "./homeData";
import { EmailSetupButton } from "./EmailCta";

const STEPS = [
  ["01", "Email us — or sign up yourself", "Email us and we'll set your company up with you, or sign up in a couple of minutes and set your pay period, time zone, branding and job types in the setup wizard."],
  ["02", "Add depots and crew", "Set up each yard, invite workers by email and give depot supervisors their own logins."],
  ["03", "Crew clocks on", "Workers install the app, see their jobs and shifts, clock on and send photos from site."],
];

export const HowItWorks = ({ onStart }) => (
  <section id="how" className="scroll-mt-16 bg-white py-24 lg:py-32" data-testid="home-how">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-[1.1fr_1fr] gap-14 items-center">
      <div>
        <SectionHead num="06" eyebrow="How it works" title="Up and running before smoko." sub="No consultants, no lock-in setup fees — just your company, your depots and your crew." />
        <div className="mt-12 space-y-4">
          {STEPS.map(([n, title, text], i) => (
            <Reveal key={n} delay={0.08 * i}>
              <div className="flex gap-6 rounded-2xl border border-slate-200 p-6 hover:border-[#1E3A5F] transition-colors" data-testid={`home-how-step-${i}`}>
                <span className="font-mono text-3xl font-bold text-[#EA580C] leading-none">{n}</span>
                <div><h4 className="font-display text-lg sm:text-xl font-bold">{title}</h4><p className="mt-1 text-slate-600">{text}</p></div>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-3">
          <EmailSetupButton testid="home-how-email-btn" tone="navy" />
          <button onClick={onStart} data-testid="home-how-start-btn" className="font-semibold text-[#1E3A5F] underline-offset-4 hover:underline hover:text-[#EA580C] transition-colors">or start a free trial yourself</button>
        </div>
      </div>
      <Reveal delay={0.15} className="relative">
        <div className="aspect-[4/5] rounded-2xl bg-cover bg-center" style={{ backgroundImage: `url(${IMG.estate})` }} role="img" aria-label="New Australian housing estate from above" />
        <div className="absolute -left-4 sm:-left-8 bottom-8 rounded-xl bg-[#0B1120] text-white p-5 shadow-2xl max-w-[260px]">
          <div className="h-1.5 w-16 home-hazard rounded-full mb-3" />
          <p className="font-display font-bold text-lg leading-snug">Every depot, one login — set up your company’s way.</p>
        </div>
      </Reveal>
    </div>
  </section>
);
